export const ROUTE_CONSTANTS = {
    DASHBOARD: 'dashboard',
    USER_MANAGEMENT:'usermanagement',
    TICKETS: 'tickets',
    INVESTIGATION_LIST: 'investigation-list',
    DRIVE_INVESTIGATION_LIST: 'drive-investigation-list',
    ELEKTRONIKON_INVESTIGATION_LIST: 'elektronikon-investigation-list',
    MOTOR_LIST: 'motor-list',
    MOTOR_EDIT: 'motor-list/edit',
    SOLUTION_RESULTS: 'solution-results',
    ENGINEERING_DASHBOARD: 'engineering-dashboard',
    APPROVAL_TASKS: 'approval-tasks',
    INTERNAL_MOTOR_SELECTION: 'internal-motor-selection',
    AVAILABLE_ALTERNATIVES: 'available-alternatives',
    COMPARISON_REPORT: 'comparison-report',
    EXTERNAL_INVESTIGATION: 'external-investigation',
    TICKET_CHECK: 'ticket-check',
    RELEASE_NOTES: 'release-notes',
}